export default "__VITE_ASSET__a41a15bc__"